<template>
      
  <div>
    <!-- 为空状态时的页面 -->
    <el-card v-if="fang == true">
      <div class="main">
        <img src="@/assets/mask/mask5.png" alt="" />
        <p>你没有收到任何消息通知，世界都清净了……</p>
      </div>
    </el-card>
    <!-- 有广告的列表 -->
    <div class="hos_table" v-loading="loading" v-if="formShow == true">
      <p class="inform">消息通知</p>
      <el-table
        :data="getData"
        style="width: 100%"
        :cell-class-name="stateColor"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <!-- <el-table-column type="selection" width="80"></el-table-column> -->
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + (currentPage3 - 1) * pageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="NoticeName" label="标题"> </el-table-column>
        <el-table-column prop="BeginTime1" label="时间"> </el-table-column>
        <el-table-column prop="RealName" label="发布者"> </el-table-column>

        <el-table-column prop="address" label="操作" align="center" width="280">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                verification="user_detail"
                type="text"
                size="small"
                @click="listmanage(scope.row)"
                >查看</el-button
              >
              <el-button
                verification="user_edit"
                type="text"
                size="small"
                :class="scope.row.IsRead == 1 ? 'gray' : ''"
                @click="ignoreBtn(scope.row)"
                :disabled="scope.row.IsRead == 1"
                >忽略</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="toHome">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import { getUserNoticeList, userCheckNotice } from "@/api/examination.js";
import loginvuex from "@/store/index";
import { newMsgCount } from "@/api/examination.js";
import qs from "qs";

export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      currentPage3: 1, //  当前页数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100, //总条数
      getData: [],
      fang: false, // 判断为空的页面是否显示
      formShow: false, // 判断表格是否显示
      loading: false,
      textColor: false, // 用于忽略颜色改变
    };
  },
  props: ["cutcoms"],
  methods: {
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      //   console.log('object', row, column, rowIndex, columnIndex)
      if (columnIndex === 0 && row.IsRead == "1") {
        return "gray";
      } else if (columnIndex === 1 && row.IsRead == "1") {
        return "gray";
      } else if (columnIndex === 2 && row.IsRead == "1") {
        return "gray";
      } else if (columnIndex === 3 && row.IsRead == "1") {
        return "gray";
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 查看
    listmanage(row) {
      this.Buriedpoint({
        code: "PersonalCenter:Alerts:detail",
        parent_code: "PersonalCenter:Alerts",
      });
      this.$parent.currentLine = row;
      this.cutcoms(1);
    },
    // 实时更新消息通知气泡数据
    async bubblesData() {
      let parmes = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      const { data } = await newMsgCount(parmes);
      if (data.Status == 200) {
        loginvuex.state.newMsg = data.Data.newMsg;
        if (data.Data.newMsg === 0) {
          loginvuex.state.isan = false;
        }
      }
    },
    // 取消返回首页
    toHome() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Alerts:back",
          parent_code: "PersonalCenter:Alerts",
        },
        "statetime"
      );
      this.$router.push("/papers");
      this.bubblesData();
    },
    // 忽略
    async ignoreBtn(row) {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Alerts:ignore",
          parent_code: "PersonalCenter:Alerts",
        },
        "statetime"
      );
      let params = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        NoticeID: row.NoticeID,
        checkType: 1, // 传0是查看，传1是忽略
        hid: JSON.parse(loginvuex.state.hid),
      };
      const { data } = await userCheckNotice(params);
      if (data.Status == 200) {
        this.$message({
          message: data.Data,
          type: "success",
        });
        this.getUserNoticeList();
        this.bubblesData();
      } else {
        this.$message.error("忽略失败!");
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.pageSize = val;
      this.getUserNoticeList(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val - 1;
      this.loading = true;
      //  sessionStorage.setItem("pageIndex", val - 1);
      this.getUserNoticeList();
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    //验证是否有消息通知列表
    async getUserNoticeList() {
      let params = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        pageIndex: this.currentPage3, // 从第几页开始
        eachPageNum: this.pageSize, // 一页多少条
      };
      const { data } = await getUserNoticeList(params);
      if (data.Data.data.length < 1) {
        this.fang = true; // 没有消息的页面
      } else {
        this.formShow = true; // 暂时表格
        if (data.Status == 200) {
          this.getData = data.Data.data;
          this.total = data.Data.count;

          this.getData.map((item) => {
            this.$set(item, "BeginTime1", ""); // 造这个数据用于保存选中的
            item.BeginTime1 =
              this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
              "-" +
              this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
          });
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.$message.error("很抱歉，数据获取不到");
        }
      }

      // console.log(data.Data.data, "请求");
      // console.log(data);
    },
  },
  created() {
    this.stateArr = [];
    this.getUserNoticeList();
    localStorage.removeItem("isreload");
  },
};
</script>
<style lang="scss" scoped>
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
.el-card {
  border: none;
}
::v-deep .el-card__body {
  padding: 44px 24px;
  // height: 820px;
  min-height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main {
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // border: 1px solid #000;
  p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #bbbbbb;
    opacity: 1;
    margin-top: 20px;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    //background-color: #333333;
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  // ::v-deep .el-pagination__jump {
  //   // &::before {
  //   //   content: "10条/页";
  //   //   width: 82px;
  //   //   border: 1px solid #d9d9d9;
  //   //   height: 28px;
  //   //   border-radius: 2px;
  //   //   text-align: center;
  //   //   display: inline-block;
  //   //   margin-right: 8px;
  //   //   cursor: pointer;
  //   // }
  // }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep .el-table-column--selection .cell {
  text-align: center;
}
::v-deep .el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
::v-deep .el-table td {
  text-align: center;
}
.hos_table {
  .inform {
    margin-bottom: 24px;
    font-weight: bold;
    border-bottom: 4px solid #1890ff;
  }
  padding: 24px 24px;
  min-height: 800px;
  background: #ffffff;
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
    padding-left: 0px;
    padding-right: 0px;
  }
  .sonbtn {
    border: 1px solid #d9d9d9 !important;
    color: #999999;
  }
  .oper_box {
    display: flex;
    margin: 14px 0px 20px 0px;
    width: 88px;
    height: 40px;
    opacity: 1;
    padding: 0px 24px !important;
    border-radius: 4px;
    ::v-deep .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      letter-spacing: 1px;
      span > i {
        font-size: 14px !important;
        margin-right: 5px;
      }
    }
    .el-button:nth-child(1) {
      background: #1890ff;
      width: 88px;
    }
    .el-button:nth-child(2) {
      background: #ee6717;
      width: 88px;
    }
    // .el-button:nth-child(3) {
    //   background: #64b5ff;
    //   width: 104px;
    // }
    .el-button:nth-child(3) {
      background: #e54d4d;
      width: 104px;
      span > i {
        font-size: 16px !important;
        margin-right: 5px;
      }
    }
  }
}
.operation_box {
  ::v-deep .el-button--text {
    font-size: 16px;
    font-weight: 400;
    margin-right: 20px;
    color: #1890ff;
  }
}
::v-deep .el-table .gray .cell {
  color: #ccc !important;
}
.gray {
  color: #ccc !important;
}
.operation {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #1890ff;
    color: #ffffff;
  }
}
</style>